import generate from './tools/generate'

function groupjoin() {
    return {
        status: null,
        group: null,
        groupHash: null,
        groupRoute: null,
    }
}

export default {
    namespaced: true,
    state: groupjoin(),
    mutations: generate.mutations(groupjoin),
}

export const GROUP_NOT_FOUND = 0
export const USER_ALREADY_JOIN_OTHER_GROUP = 1
export const USER_JOIN = 2
export const USER_AUTH = 3
